import React from "react";

const Line = () => {
  return (
    <div
      style={{
        background: "linear-gradient(90deg, rgba(192, 193, 195, 0.01) 0%, rgba(192, 193, 195, 0.08) 33.33%, rgba(192, 193, 195, 0.08) 66.67%, rgba(192, 193, 195, 0.01) 100%)",
        width: "100%",
        height: "1px"
      }}
    />
  );
};

export default Line;
